/*!

=========================================================
*  Dashboard React - v1.1.0
=========================================================
*/
import React from "react";
import ReactDOM from "react-dom";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import 'react-toastify/dist/ReactToastify.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

import App from "./App";




ReactDOM.render(
  <App />,
  document.getElementById("root")
);
